import _classCallCheck from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { SVGNS } from './core';
import { RoughGenerator } from './generator';
export var RoughSVG = /*#__PURE__*/function () {
  function RoughSVG(svg, config) {
    _classCallCheck(this, RoughSVG);

    this.svg = svg;
    this.gen = new RoughGenerator(config);
  }

  _createClass(RoughSVG, [{
    key: "draw",
    value: function draw(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.getDefaultOptions();
      var doc = this.svg.ownerDocument || window.document;
      var g = doc.createElementNS(SVGNS, 'g');

      var _iterator = _createForOfIteratorHelper(sets),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var drawing = _step.value;
          var path = null;

          switch (drawing.type) {
            case 'path':
              {
                path = doc.createElementNS(SVGNS, 'path');
                path.setAttribute('d', this.opsToPath(drawing));
                path.setAttribute('stroke', o.stroke);
                path.setAttribute('stroke-width', o.strokeWidth + '');
                path.setAttribute('fill', 'none');

                if (o.strokeLineDash) {
                  path.setAttribute('stroke-dasharray', o.strokeLineDash.join(' ').trim());
                }

                if (o.strokeLineDashOffset) {
                  path.setAttribute('stroke-dashoffset', "".concat(o.strokeLineDashOffset));
                }

                break;
              }

            case 'fillPath':
              {
                path = doc.createElementNS(SVGNS, 'path');
                path.setAttribute('d', this.opsToPath(drawing));
                path.setAttribute('stroke', 'none');
                path.setAttribute('stroke-width', '0');
                path.setAttribute('fill', o.fill || '');

                if (drawable.shape === 'curve' || drawable.shape === 'polygon') {
                  path.setAttribute('fill-rule', 'evenodd');
                }

                break;
              }

            case 'fillSketch':
              {
                path = this.fillSketch(doc, drawing, o);
                break;
              }
          }

          if (path) {
            g.appendChild(path);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return g;
    }
  }, {
    key: "fillSketch",
    value: function fillSketch(doc, drawing, o) {
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      var path = doc.createElementNS(SVGNS, 'path');
      path.setAttribute('d', this.opsToPath(drawing));
      path.setAttribute('stroke', o.fill || '');
      path.setAttribute('stroke-width', fweight + '');
      path.setAttribute('fill', 'none');

      if (o.fillLineDash) {
        path.setAttribute('stroke-dasharray', o.fillLineDash.join(' ').trim());
      }

      if (o.fillLineDashOffset) {
        path.setAttribute('stroke-dashoffset', "".concat(o.fillLineDashOffset));
      }

      return path;
    }
  }, {
    key: "generator",
    get: function get() {
      return this.gen;
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return this.gen.defaultOptions;
    }
  }, {
    key: "opsToPath",
    value: function opsToPath(drawing) {
      return this.gen.opsToPath(drawing);
    }
  }, {
    key: "line",
    value: function line(x1, y1, x2, y2, options) {
      var d = this.gen.line(x1, y1, x2, y2, options);
      return this.draw(d);
    }
  }, {
    key: "rectangle",
    value: function rectangle(x, y, width, height, options) {
      var d = this.gen.rectangle(x, y, width, height, options);
      return this.draw(d);
    }
  }, {
    key: "ellipse",
    value: function ellipse(x, y, width, height, options) {
      var d = this.gen.ellipse(x, y, width, height, options);
      return this.draw(d);
    }
  }, {
    key: "circle",
    value: function circle(x, y, diameter, options) {
      var d = this.gen.circle(x, y, diameter, options);
      return this.draw(d);
    }
  }, {
    key: "linearPath",
    value: function linearPath(points, options) {
      var d = this.gen.linearPath(points, options);
      return this.draw(d);
    }
  }, {
    key: "polygon",
    value: function polygon(points, options) {
      var d = this.gen.polygon(points, options);
      return this.draw(d);
    }
  }, {
    key: "arc",
    value: function arc(x, y, width, height, start, stop) {
      var closed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var options = arguments.length > 7 ? arguments[7] : undefined;
      var d = this.gen.arc(x, y, width, height, start, stop, closed, options);
      return this.draw(d);
    }
  }, {
    key: "curve",
    value: function curve(points, options) {
      var d = this.gen.curve(points, options);
      return this.draw(d);
    }
  }, {
    key: "path",
    value: function path(d, options) {
      var drawing = this.gen.path(d, options);
      return this.draw(drawing);
    }
  }]);

  return RoughSVG;
}();